import 'what-input'
import { initData } from './init-data.js'

import './index.scss'
import { View } from './view.js'

window.addEventListener('load', () => {
    const container = document.querySelector('#root')!

    const view = new View(container)

    // Initial render
    view.update()

    window.addEventListener('hashchange', () => {
        // Check if there's a room ID in the URL hash
        view.checkUrlForRoomId()
        view.update()
    })

    // Clean up when the window unloads
    window.addEventListener('unload', () => view.destroy())

    initData(view).catch((error) => console.error(error))
})
